export default __webpack_public_path__ + "static/media/full.aef58a67.jpg";